import { CSSProperties } from "react";
import { AgentIcon, FactionType } from "~/business";
import { parseEnumOrError } from "~/utils";
import { XFactionChangeDiamondSvg, XFactionQuestionMarkSvg } from "./svg";
import { XAgentIcon } from "./XAgentIcon";
import { XCenteredAbsolute } from "./XCenteredAbsolute";

export const XFactionDiamond = ({
  width,
  faction,
  style,
}: {
  width: number;
  faction?: FactionType;
  style?: CSSProperties;
}) => {
  return (
    <div style={{ position: "relative", ...style }}>
      <XFactionChangeDiamondSvg width={width} />
      <XCenteredAbsolute>
        {faction ? (
          <XAgentIcon
            agentIcon={parseEnumOrError(AgentIcon, faction)}
            width={width * 0.6}
          />
        ) : (
          <XFactionQuestionMarkSvg width={width * 0.4} />
        )}
      </XCenteredAbsolute>
    </div>
  );
};
